__turbopack_context__.v({
  "EventCardList": "IJT2WW_EventCardList",
  "LoadingSpinnerWrapper": "IJT2WW_LoadingSpinnerWrapper",
  "NoResults": "IJT2WW_NoResults",
  "SingleColumn": "IJT2WW_SingleColumn",
});
